/**
 * 对比结果
 */
export var COMPARE_RESULT;

(function (COMPARE_RESULT) {
  COMPARE_RESULT[COMPARE_RESULT["GREATR"] = 1] = "GREATR";
  COMPARE_RESULT[COMPARE_RESULT["EQUAL"] = 0] = "EQUAL";
  COMPARE_RESULT[COMPARE_RESULT["LESS"] = -1] = "LESS";
})(COMPARE_RESULT || (COMPARE_RESULT = {}));
/**
 * 版本比较
 * @param {string} version1 版本号
 * @param {string} version2 版本号
 * @returns {number}
 * | 结果 | 说明 |
 * |:-----:|:-------:|
 * |1|version1>version2|
 * |-1|version1<version2|
 * |0|version1=version2|
 *
 * @example
 * 使用方式
 *
 * ```javascript
 * import { versionCompare } from '@kibt/web-utils/version';
 *
 * versionCompare('5.9.30', '5.8.30') === 1;
 */


export function versionCompare(version1, version2) {
  if (!version1) {
    version1 = '';
  }

  if (!version2) {
    version2 = '';
  }

  function padLength(arr) {
    arr.push('0');
    return arr;
  }

  try {
    var v1 = version1.toString().split('.');
    var v2 = version2.toString().split('.');
    var len = Math.max(v1.length, v2.length);

    while (v1.length < len) {
      v1 = padLength(v1);
    }

    while (v2.length < len) {
      v2 = padLength(v2);
    }

    for (var i = 0; i < len; i++) {
      var num1 = parseInt(v1[i], 10);
      var num2 = parseInt(v2[i], 10);

      if (num1 > num2) {
        return COMPARE_RESULT.GREATR;
      }

      if (num1 < num2) {
        return COMPARE_RESULT.LESS;
      }
    }

    return COMPARE_RESULT.EQUAL;
  } catch (_unused) {
    return COMPARE_RESULT.EQUAL;
  }
}